"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EdcSubjectVisitCrfSavingStatus = void 0;
var EdcSubjectVisitCrfSavingStatus;
(function (EdcSubjectVisitCrfSavingStatus) {
    EdcSubjectVisitCrfSavingStatus["NotAvailable"] = "NA";
    EdcSubjectVisitCrfSavingStatus["None"] = "NONE";
    EdcSubjectVisitCrfSavingStatus["Saved"] = "SAVED";
    EdcSubjectVisitCrfSavingStatus["Temporary"] = "TEMP";
})(EdcSubjectVisitCrfSavingStatus = exports.EdcSubjectVisitCrfSavingStatus || (exports.EdcSubjectVisitCrfSavingStatus = {}));
// {folderId}:{visitId}:{visitSeq}:{crfId}:{itemId},{value}
// {folderId}:{visitId}:{visitSeq}:{crfId}:{itemId}:{itemSeq}:{subItemId},{value}
//# sourceMappingURL=subject.js.map